module.exports = __webpack_public_path__ + "static/media/badge-catalan-provisional.e4fa72f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badges/badge-catalan-provisional.png
// module id = 605
// module chunks = 0